var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.83em",
    height: "1em",
    viewBox: "0 0 256 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b4b",
    d: "M123.888 2.182c1.92-2.91 6.258-2.91 8.25 0l40.753 60.75l43.321 64.519a18 18 0 0 1-1.764 2.581c-.452.539-.88 1.048-1.414 1.571l-.011-.005l.01.005c-.117.112-.23.2-.37.306l-.15.115q-.735.549-1.514 1.038c-.42.263-.767.495-1.269.736c-.5.242-1.302.532-1.784.697c-.483.167-.644.223-1 .302c-.178.035-.356.07-.533.092q-.182.033-.363.057c-.021.007-.05.007-.07.014l-.542.064c-.568.057-1.159.086-1.763.086a697.8 697.8 0 0 1-151.26 0q-.086.002-.172-.008h-.17l-.079-.007h-.077c-.058-.007-.115-.007-.171-.014h-.057c-.079-.007-.15-.007-.227-.014c-.47-.036-1.016-.154-1.408-.241c-.393-.079-.627-.143-.953-.215c-3.87-.917-7.424-3.25-9.053-7.025c-.043-.1-.079-.199-.122-.299l-.006-.021L.225 26.025c-1.067-2.844 1.85-5.69 4.693-4.338c.072 0 .214 0 .286.071l77.902 41.173Zm127.006 19.577c2.852-1.564 5.91 1.137 4.914 4.124v.143l-39.595 101.426l-43.321-64.52l77.931-41.173Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7d353b",
    d: "M250.894 21.759h-.07l-77.932 41.173l43.321 64.52l39.595-101.426v-.143c.996-2.987-2.062-5.688-4.914-4.124"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#bd4043",
    d: "M132.138 2.182c-1.992-2.91-6.33-2.91-8.25 0l-40.782 60.75l44.878 23.723l85.05 44.948c.534-.523.962-1.032 1.414-1.57a18 18 0 0 0 1.764-2.582l-43.32-64.519z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlit);
export default __webpack_public_path__ + "static/media/streamlit.c9a74a570059e4dcc43a43c4ff5d3a21.svg";
export { ForwardRef as ReactComponent };